// extracted by mini-css-extract-plugin
export var btn = "style-module--btn--54ebd";
export var content = "style-module--content--babb3";
export var intro = "style-module--intro--82337";